import React, { useEffect, useState } from 'react';
import { Row, Card, Button, Form, Col } from 'react-bootstrap';
// import TextInput from "../common/TextInput.jsx"
import { Formik } from 'formik';
import * as Yup from 'yup';
// import { addRole, getRole, updateRole } from "../../services/RoleService"
import { toast } from '../../common/Toast/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { addRole, getRole, updateRole } from '../../../../services/RolesServices.js';
import TextInput from '../../common/FormFields/TextInput.jsx';
// import { getRole } from "../../services/RoleService.js"

const AddRole = ({
  // Shown inside a dialog rather than as a page: the component drops its
  // own back-link and toast host, since the dialog and the list supply
  // them. The card chrome around it is flattened by SettingsFormModal.css.
  embedded = false,
  // The record to edit. Falls back to the :id route param.
  recordId,
  // Called after a successful save instead of navigating away.
  onDone,
  // Called when the form is dismissed instead of navigating away.
  onCancel,
}) => {
  const navigate = useNavigate();

  // Leaving the form means "go back to the list" on the route, and "close
  // the dialog" when embedded. Every exit goes through these two so the
  // component never has to know which it is.
  const leave = () => {
    if (onCancel) onCancel();
    else navigate('/setting/list-Roles');
  };

  const finish = () => {
    if (onDone) onDone();
    else navigate('/setting/list-Roles');
  };
  const { id: routeId } = useParams();
  const id = recordId ?? routeId;
  const [roleData, setRoleData] = useState({ label: '', value: '' });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (id) {
      fetchRoleDetails(id);
    } else {
      setRoleData({ label: '', value: '' });
      setIsEditing(false);
    }
  }, [id]);

  const fetchRoleDetails = async (roleId) => {
    try {
      const response = await getRole(roleId);
      // console.log('API Response:', response); // Debug log

      // Handle different response structures
      let roleData = null;

      if (response.data) {
        // If data is an array, get the first item
        if (Array.isArray(response.data)) {
          roleData = response.data[0];
        } else {
          // If data is an object
          roleData = response.data;
        }
      }

      if (roleData) {
        setRoleData({
          label: roleData.label || '',
          value: roleData.value || '',
        });
        setIsEditing(true);
      } else {
        console.error('No role data found');
        toast.error('Role not found!');
        // '/setting/role' was not a route -- the list is '/setting/list-Roles'
        // -- so this landed on the 404 page. leave() goes wherever the form
        // is standing: back to the list, or out of the dialog.
        leave();
      }
    } catch (error) {
      console.error('Error fetching role details:', error);
      toast.error('Error fetching role details!');
      leave();
    }
  };

  const validationSchema = Yup.object().shape({
    label: Yup.string()
      .required('Label is required')
      .matches(/^[a-zA-Z0-9 ]*$/, 'Label should not contain special characters'),
  });

  // Function to generate value
  const generateValue = (label) => {
    return label
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, ''); // Remove special characters
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = {
        label: values.label,
        value: generateValue(values.label),
      };

      if (isEditing) {
        await updateRole(id, formattedValues);
        toast.success('Role updated successfully!');
      } else {
        await addRole(formattedValues);
        toast.success('Role added successfully!');
      }

      resetForm();
      finish();
    } catch (error) {
      console.error('Error processing role:', error);
      toast.error('Error processing role!');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* Page-only: the list behind the dialog has its own toast host, and
          two would show every message twice. */}
      {!embedded && (
        <>
          <Link to="/setting/list-Roles">
            <Button variant="primary">Go to Role List</Button>
          </Link>
        </>
      )}
      <Formik
        enableReinitialize
        initialValues={roleData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
          <Form onSubmit={handleSubmit} className="p-4">
            <h4>{isEditing ? 'Edit Role' : 'Add Role'}</h4>
            <Card className="p-4">
              <Row className="mb-3">
                <TextInput
                  label="Label"
                  name="label"
                  value={values.label}
                  onChange={(e) => {
                    const labelValue = e.target.value;
                    setFieldValue('label', labelValue);
                    setFieldValue('value', generateValue(labelValue)); // Auto-update value
                  }}
                />
              </Row>
              <Row className="mb-3">
                <TextInput label="Value" name="value" value={values.value} readOnly />
              </Row>
              <Row className="mt-3">
                <Col md={3} className="text-start">
                  <Button variant="danger" size="sm" type="button" onClick={leave}>
                    Cancel
                  </Button>
                </Col>
                <Col className="text-end me-3">
                  <Button variant="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Processing...' : isEditing ? 'Update' : 'Submit'}
                  </Button>
                </Col>
              </Row>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddRole;
